import { FrontendLogger } from '@/logging/FrontendLogger'
import { useRecoilValue } from 'recoil'
import { LoggerSelectorFamily } from '@/atoms/logger'

export const useLogger = (componentName: string): FrontendLogger => {
    return useRecoilValue(LoggerSelectorFamily(componentName))
}
